import React, { useEffect, useState, useRef } from 'react';
import IconButton from './IconButton';
import { FaBell } from 'react-icons/fa';
import api from '../services/api';
import Alert from './Alert';
import ModalNotificacoes from './ModalNotificacoes';
import { getAuthToken } from '../util/authSession';

export default function Notificacoes() {
    const token = getAuthToken();
    const [notificacoes, setNotificacoes] = useState([]);
    const [dados, setDados] = useState({
        temNovas: false,
        quantidade: 0,
        carregado: false
    });
    const [modalAberto, setModalAberto] = useState(false);
    const [carregandoModal, setCarregandoModal] = useState(false);

    // Função global para marcar notificação como lida (usada pelos links no popup)
    const marcarNotificacaoComoLida = (notificacaoId) => {
        return new Promise((resolve, reject) => {
            // Marca a notificação como lida imediatamente
            api({
                method: 'put',
                action: '/notificacao/' + notificacaoId,
                token: token,
                data: {
                    situacao: "lido"
                }
            })
                .then(function (response) {
                    // Atualiza a contagem após marcar como lida
                    setDados(prev => ({
                        ...prev,
                        quantidade: Math.max(0, prev.quantidade - 1),
                        temNovas: prev.quantidade - 1 > 0
                    }));

                    // Fecha o popup do SweetAlert
                    if (window.Swal) {
                        window.Swal.close();
                    }

                    console.log('Notificação marcada como lida:', notificacaoId);
                    resolve(response);
                })
                .catch(function (error) {
                    console.error('Erro ao marcar notificação como lida:', error);
                    reject(error);
                });
        });
    };

    // Adiciona a função ao escopo global para ser acessível pelos links
    if (typeof window !== 'undefined') {
        window.marcarNotificacaoComoLida = marcarNotificacaoComoLida;

        // Função global para executar verificação de eventos pendentes manualmente
        window.verificarEventosPendentes = () => {
            console.log('🎮 [EVENTOS] Execução manual forçada via window.verificarEventosPendentes()');
            const isMountedRef = { current: true };
            verificarEventosPendentes(isMountedRef, true); // Força execução
        };

        // Função global para marcar como lida e navegar
        window.marcarComoLidaENavegar = (notificacaoId, url, novaAba = false) => {
            // Desabilita os botões para evitar cliques múltiplos
            const buttons = document.querySelectorAll('button[onclick*="marcarComoLidaENavegar"]');
            buttons.forEach(button => {
                button.disabled = true;
                button.style.opacity = '0.6';
                button.textContent = '⏳ Processando...';
            });

            // Usa a função Promise para marcar como lida
            marcarNotificacaoComoLida(notificacaoId)
                .then(function (response) {
                    console.log('Notificação marcada como lida com sucesso:', notificacaoId);

                    // Aguarda um pouco mais para garantir que o backend processou
                    setTimeout(() => {
                        if (novaAba) {
                            window.open(url, '_blank');
                        } else {
                            window.location.href = url;
                        }
                    }, 500);
                })
                .catch(function (error) {
                    console.error('Erro ao marcar notificação como lida:', error);

                    // Reabilita os botões em caso de erro
                    buttons.forEach(button => {
                        button.disabled = false;
                        button.style.opacity = '1';
                        button.textContent = novaAba ? '🔗 Nova Aba' : '📄 Mesma Aba';
                    });

                    // Mesmo com erro, ainda tenta navegar após um delay maior
                    setTimeout(() => {
                        if (novaAba) {
                            window.open(url, '_blank');
                        } else {
                            window.location.href = url;
                        }
                    }, 500);
                });
        };
    }

    const mostraAlerta = (notificacao) => {
        var iconeAlerta = "info";
        if (notificacao.tipo === 'informacao') {
            iconeAlerta = "info";
        };
        if (notificacao.tipo === 'atencao') {
            iconeAlerta = "warning";
        };
        if (notificacao.tipo === 'erro') {
            iconeAlerta = "error";
        };
        if (notificacao.tipo === 'sucesso') {
            iconeAlerta = "success";
        };

        // Monta o HTML da notificação incluindo o link se existir
        let htmlContent = `
            <div style="text-align: left; margin-bottom: ${notificacao.link ? '15px' : '0'};">
                ${notificacao.texto}
                ${notificacao.link ? '<br><small style="color: #6c757d; font-style: italic;">🔗 Esta notificação contém um link</small>' : ''}
            </div>
        `;

        if (notificacao.link) {
            htmlContent += `
                <div style="
                    margin-top: 15px; 
                    padding-top: 15px; 
                    border-top: 1px solid #eee;
                    display: flex;
                    gap: 10px;
                    justify-content: center;
                ">
                    <button 
                       onclick="marcarComoLidaENavegar('${notificacao.id}', '${notificacao.link}', true)"
                       style="
                           display: inline-block;
                           background-color: #007bff;
                           color: white;
                           padding: 8px 16px;
                           text-decoration: none;
                           border-radius: 4px;
                           font-size: 14px;
                           transition: all 0.2s;
                           border: none;
                           cursor: pointer;
                           margin-right: 5px;
                       "
                       onmouseover="this.style.backgroundColor='#0056b3'; this.style.transform='translateY(-1px)'"
                       onmouseout="this.style.backgroundColor='#007bff'; this.style.transform='translateY(0)'">
                        🔗 Nova Aba
                    </button>
                    <button 
                       onclick="marcarComoLidaENavegar('${notificacao.id}', '${notificacao.link}', false)"
                       style="
                           display: inline-block;
                           background-color: #28a745;
                           color: white;
                           padding: 8px 16px;
                           text-decoration: none;
                           border-radius: 4px;
                           font-size: 14px;
                           transition: all 0.2s;
                           border: none;
                           cursor: pointer;
                       "
                       onmouseover="this.style.backgroundColor='#1e7e34'; this.style.transform='translateY(-1px)'"
                       onmouseout="this.style.backgroundColor='#28a745'; this.style.transform='translateY(0)'">
                        📄 Mesma Aba
                    </button>
                </div>
            `;
        }

        Alert({
            callBack: (result) => {
                //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                if (result.isConfirmed) {
                    api({
                        method: 'put',
                        action: '/notificacao/' + notificacao.id,
                        token: token,
                        data: {
                            situacao: "lido"
                        }
                    })
                        .then(function (response) {
                            // Atualiza a contagem após marcar como lida
                            setDados(prev => ({
                                ...prev,
                                quantidade: Math.max(0, prev.quantidade - 1),
                                temNovas: prev.quantidade - 1 > 0
                            }));
                        })
                        .catch(function (error) {
                            //alert(error)
                        });
                }
            },
            icon: iconeAlerta,
            html: htmlContent,
            confirmButton: notificacao.link ? null : "Fechar", // Só mostra botão "Fechar" se não tiver link
        });

    };

    const buscarContagem = (isMountedRef) => {
        api({
            method: 'get',
            action: '/notificacao',
            token: token,
        })
            .then(response => {
                // Verifica se o componente ainda está montado antes de atualizar o estado
                if (!isMountedRef || !isMountedRef.current) {
                    return;
                }

                var notificacoes = response.data.data;
                var quantidadeNovas = 0;
                var temNovas = false;
                var agora = new Date();

                for (const notificacao of notificacoes) {
                    var dataNotificacao = new Date(notificacao.data);
                    if (notificacao.situacao === "nova") {
                        quantidadeNovas++;
                        temNovas = true;
                        // Só mostra popup se a notificação tiver popup = true e for recente (10 minutos)
                        if (notificacao.popup && dataNotificacao - agora < 600000) {
                            mostraAlerta(notificacao);
                        }
                    }
                }

                setDados(prevDados => ({
                    ...prevDados,
                    temNovas: temNovas,
                    quantidade: quantidadeNovas
                }));
            }).catch(err => {
                //console.log(err)
            });
    };

    const carregarNotificacoes = (isMountedRef) => {
        if (dados.carregado && !carregandoModal) return; // Evita carregar novamente se já foi carregado

        setCarregandoModal(true);

        api({
            method: 'get',
            action: '/notificacao',
            token: token,
        })
            .then(response => {
                // Verifica se o componente ainda está montado antes de atualizar o estado
                if (!isMountedRef || !isMountedRef.current) {
                    return;
                }

                var notificacoes = response.data.data;
                setNotificacoes(notificacoes);
                setDados(prevDados => ({ ...prevDados, carregado: true }));
                setCarregandoModal(false);
            }).catch(err => {
                console.error('Erro ao carregar notificações:', err);
                if (isMountedRef && isMountedRef.current) {
                    setCarregandoModal(false);
                }
            });
    };

    const handleModalClick = () => {
        setModalAberto(true);
        const isMountedRef = { current: true };
        carregarNotificacoes(isMountedRef); // Sempre carrega as notificações ao abrir o modal
    };

    const handleMarcarComoLida = (notificacao) => {
        // Marca como lida sem mostrar o alerta
        api({
            method: 'put',
            action: '/notificacao/' + notificacao.id,
            token: token,
            data: {
                situacao: "lido"
            }
        })
            .then(function (response) {
                // Atualiza a contagem após marcar como lida
                setDados(prev => ({
                    ...prev,
                    quantidade: Math.max(0, prev.quantidade - 1),
                    temNovas: prev.quantidade - 1 > 0
                }));

                // Recarrega as notificações após marcar como lida
                setTimeout(() => {
                    carregarNotificacoes();
                    buscarContagem();
                }, 500);
            })
            .catch(function (error) {
                console.error('Erro ao marcar notificação como lida:', error);
            });
    };

    // Função para verificar eventos pendentes
    const verificarEventosPendentes = (isMountedRef, forcarExecucao = false) => {
        console.log('🔄 [EVENTOS] verificarEventosPendentes chamada', {
            forcarExecucao,
            componenteMontado: isMountedRef?.current,
            timestamp: new Date().toISOString()
        });

        if (!isMountedRef || !isMountedRef.current) {
            console.log('⚠️ [EVENTOS] Verificação cancelada - componente não montado');
            return;
        }

        const agora = Date.now();
        const ultimaExecucao = localStorage.getItem('ultimaVerificacaoEventosPendentes');
        const intervaloMinimo = 30 * 60 * 1000; // 30 minutos em ms

        console.log('📊 [EVENTOS] Verificando condições de execução:', {
            ultimaExecucao: ultimaExecucao ? new Date(parseInt(ultimaExecucao)).toISOString() : null,
            tempoDecorrido: ultimaExecucao ? Math.round((agora - parseInt(ultimaExecucao)) / 1000 / 60) + 'min' : 'Nunca',
            intervaloMinimo: '30min',
            forcarExecucao
        });

        // Se não for execução forçada, verifica se já executou recentemente
        if (!forcarExecucao && ultimaExecucao && (agora - parseInt(ultimaExecucao)) < intervaloMinimo) {
            console.log('⏭️ [EVENTOS] Verificação pulada - já executada recentemente');
            return;
        }

        console.log('▶️ [EVENTOS] Iniciando verificação de eventos pendentes...');

        api({
            method: 'post',
            action: '/evento/verificar-pendentes',
            token: token,
        })
            .then(response => {
                // Salva timestamp da última execução bem-sucedida
                localStorage.setItem('ultimaVerificacaoEventosPendentes', agora.toString());
                console.log('✅ [EVENTOS] Verificação executada com sucesso:', {
                    mensagem: response.data?.mensagem,
                    timestamp: new Date().toISOString(),
                    proximaExecucao: new Date(agora + intervaloMinimo).toISOString()
                });
            })
            .catch(err => {
                console.log('❌ [EVENTOS] Erro na verificação:', {
                    erro: err?.response?.data?.message || err.message,
                    status: err?.response?.status,
                    timestamp: new Date().toISOString()
                });
                // Não mostra erro para o usuário, apenas log no console
            });
    };

    useEffect(() => { //onload
        console.log('🚀 [NOTIFICACOES] Componente Notificacoes montado');

        const isMountedRef = { current: true };

        buscarContagem(isMountedRef);

        // Verifica notificações a cada 30 segundos
        const notificacoesInterval = setInterval(() => {
            console.log('🔄 [NOTIFICACOES] Executando busca de notificações (30s)');
            buscarContagem(isMountedRef);
        }, 30000);

        // Verifica eventos pendentes a cada 10 minutos (600.000ms)
        const eventosInterval = setInterval(() => {
            console.log('⏰ [EVENTOS] Timer de 10 minutos disparado');
            verificarEventosPendentes(isMountedRef, false); // Não força execução
        }, 600000); // 10 minutos

        // Verifica se deve executar verificação inicial baseada no tempo
        const agora = Date.now();
        const ultimaExecucao = localStorage.getItem('ultimaVerificacaoEventosPendentes');
        const intervaloMinimo = 30 * 60 * 1000; // 30 minutos

        console.log('🔍 [EVENTOS] Analisando execução inicial:', {
            ultimaExecucao: ultimaExecucao ? new Date(parseInt(ultimaExecucao)).toISOString() : null,
            tempoDecorrido: ultimaExecucao ? Math.round((agora - parseInt(ultimaExecucao)) / 1000 / 60) + 'min' : 'Nunca',
            intervaloMinimo: '30min'
        });

        // Só executa verificação inicial se:
        // 1. Nunca executou antes, OU
        // 2. Já passou mais de 30 minutos da última execução
        const deveExecutarInicial = !ultimaExecucao || (agora - parseInt(ultimaExecucao)) >= intervaloMinimo;

        if (deveExecutarInicial) {
            console.log('⏳ [EVENTOS] Agendando verificação inicial em 5 segundos...');
            // Executa verificação inicial após 5 segundos
            const initialTimeout = setTimeout(() => {
                console.log('🎯 [EVENTOS] Executando verificação inicial');
                verificarEventosPendentes(isMountedRef, false);
            }, 5000);
        } else {
            console.log('⏭️ [EVENTOS] Verificação inicial pulada (executada recentemente)');
        }

        // Limpa os intervalos quando o componente for desmontado
        return () => {
            console.log('🛑 [NOTIFICACOES] Componente Notificacoes desmontado');
            isMountedRef.current = false;
            clearInterval(notificacoesInterval);
            clearInterval(eventosInterval);
        };
    },
        // eslint-disable-next-line
        []);

    return (
        <li key={"notificacoes"}>
            <IconButton
                icon={
                    <div style={{ position: 'relative' }}>
                        <FaBell color={dados.temNovas ? '#FF0000' : "#727e8c"} />
                        {dados.quantidade > 0 && (
                            <span
                                style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-8px',
                                    backgroundColor: '#FF0000',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    fontSize: '11px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold'
                                }}
                            >
                                {dados.quantidade > 99 ? '99+' : dados.quantidade}
                            </span>
                        )}
                    </div>
                }
                onClick={handleModalClick}
            />

            <ModalNotificacoes
                isOpen={modalAberto}
                onClose={() => setModalAberto(false)}
                notificacoes={notificacoes}
                onMarcarComoLida={handleMarcarComoLida}
                carregando={carregandoModal}
            />
        </li>
    );
}
